export function openDetailsElementFromNavigation(window) {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    if (!params.has('tab')) {
        return;
    }

    const details = document.querySelector(`#${params.get('tab')}`);

    if (details) {
        details.open = true;

        setTimeout(() => {
            details.scrollIntoView();
        }, 500);
    }
}
